// import React, { useState, useEffect } from 'react';
// import logo from '../images/logo_page.png';
// import Dropdown from 'react-bootstrap/Dropdown';
// import ReactCountryFlag from 'react-country-flag';
// import Form from 'react-bootstrap/Form';
// import { useUserAuth } from '../context/UserAuthContext';
// import { useNavigate } from 'react-router-dom';
// import countries from '../utils/countries';
// import { PushNotifications } from '@capacitor/push-notifications';

// const TWILIO_SUPPORTED_CODES = new Set([
//   '+966', // Saudi Arabia
//   '+20',  // Egypt
//   '+971', // UAE
//   '+965', // Kuwait
//   '+974', // Qatar
//   '+973', // Bahrain
//   '+968', // Oman
//   '+44',  // United Kingdom
//   '+33',  // France
//   '+49',  // Germany
//   '+1',   // United States & Canada
//   '+91',  // India
//   '+27',  // South Africa
// ]);

// const PhysioNewSignUpPhone = () => {
//   const navigate = useNavigate();
//   const [mobileNumber, setMobileNumber] = useState('');
//   const [countryCode, setCountryCode] = useState('+91');
//   const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(false);
//   const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
//   const [error, setError] = useState('');
//   const [number, setNumber] = useState('');
//   const { setUpRecaptcha, setResult, checkPhysioExist, setPermission } = useUserAuth();
//   const [showPopup, setShowPopup] = useState(false);
//   const [showErrorPopup, setShowErrorPopup] = useState(false);
//   const [otpRequested, setOtpRequested] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [searchQuery, setSearchQuery] = useState('');

//   const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

//   useEffect(() => {

//     const initializeFeatures = async () => {
//       try {
//         // 1. Get user's country based on geolocation
//         if (navigator.geolocation) {
//           navigator.geolocation.getCurrentPosition(
//             async (position) => {
//               const { latitude, longitude } = position.coords;
//               try {
//                 const response = await fetch(`https://geocode.xyz/${latitude},${longitude}?json=1`);
//                 const data = await response.json();
//                 const userCountry = countries.find(country => country.name === data.country);
//                 if (userCountry) {
//                   setCountryCode(userCountry.code);
//                 }
//               } catch (error) {
//                 console.error("Geocoding error:", error);
//               }
//             },
//             (error) => {
//               console.error("Geolocation error:", error);
//             }
//           );
//         }

//         // 2. For non-Safari browsers, request permission automatically
//         if ('Notification' in window && !isSafari) {
//           try {
//             const permission = await Notification.requestPermission();
//             setPermission(permission);
//           } catch (error) {
//             console.error("Notification permission error:", error);
//           }
//         }
//       } catch (error) {
//         console.error("Initialization error:", error);
//       }
//     };

//     initializeFeatures();
//   }, []);

//   const handlePhoneNumberChange = (e) => {
//     const inputNumber = e.target.value.replace(/\D/g, '');
//     const selectedCountry = countries.find(country => country.code === countryCode);
//     const phoneLength = selectedCountry.phoneLength;
//     const limitedInput = inputNumber.slice(0, 15); // Limit to 15 digits to accommodate various country formats
//     const isValid = limitedInput.length === phoneLength;
//     setIsPhoneNumberValid(true);
//     setMobileNumber(limitedInput);
//     let numberToSend = limitedInput;

//     if (numberToSend.startsWith('0') && numberToSend.length > 1) {
//       numberToSend = numberToSend.substring(1);
//     }
//     setNumber(numberToSend);
//   };

//   const getOtpViaTwilio = async () => {
//     const fullPhoneNumber = `${countryCode}${number}`;
//     console.log('Requesting Twilio OTP for:', fullPhoneNumber);

//     const response = await fetch(`https://twilioverifyotp-284536061530.us-central1.run.app/request-otp`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         phoneNumber: fullPhoneNumber,
//         channel: 'sms',
//         service: 'Wizphys AI',
//       })
//     });

//     const data = await response.json();

//     if (response.ok && data.success) {
//       navigate(`/otp/${countryCode.substring(1)}/${number}`);
//     } else {
//       throw new Error(data.details || "Failed to send OTP. Please try again.");
//     }
//   };

//   // ✅ Firebase OTP path (unsupported countries)
//   const getOtpViaFirebase = async () => {
//     console.log('Requesting Firebase OTP for:', countryCode, number);
//     const result = await setUpRecaptcha(number, countryCode);
//     setResult(result);
//     navigate(`/otp/${countryCode.substring(1)}/${number}`);
//   };

//   const getOtp = async (e) => {
//     setOtpRequested(true);
//     setIsLoading(true);
//     e.preventDefault();
//     setError('');

//     try {
//       // For Safari, request notification permission as part of the button click
//       if (isSafari && 'Notification' in window) {
//         try {
//           const permission = await Notification.requestPermission();
//           setPermission(permission);
//         } catch (error) {
//           console.error("Safari notification permission error:", error);
//         }
//       }

//       if (isTwilioCountry) {
//         await getOtpViaTwilio();
//       } else {
//         await getOtpViaFirebase();
//       }

//       // const fullPhoneNumber = `${countryCode}${number}`;
//       // console.log('fullPhoneNumber', fullPhoneNumber);

//       // const response = await fetch(`https://twilioverifyotp-284536061530.us-central1.run.app/request-otp`, {
//       //   method: 'POST',
//       //   headers: { 'Content-Type': 'application/json' },
//       //   body: JSON.stringify({
//       //     phoneNumber: fullPhoneNumber,
//       //     channel: 'sms',
//       //     service: 'Wizphys AI',
//       //   })
//       // });

//       // const data = await response.json();

//       // if (response.ok && data.success) {
//       //   // Navigate to OTP page if successful
//       //   navigate(`/otp/${countryCode.substring(1)}/${number}`);
//       // } else {
//       //   setError(data.details || "Failed to send OTP. Please try again.");
//       // }
//       // console.log('number', number);
//       // const response = await setUpRecaptcha(number, countryCode);
//       // console.log('response from captcha ', response);
//       // setResult(response);

//       // if (isPhoneNumberValid && isCheckboxChecked) {
//       //   navigate(`/otp/${countryCode.substring(1)}/${mobileNumber}`);
//       // }
//     } catch (err) {
//       if (err.code === 'auth/invalid-phone-number') 
//         setError("Invalid phone number. Please check the number and try again.");
//       console.log(err.code);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleCheckboxChange = (e) => {
//     setIsCheckboxChecked(e.target.checked);
//   };

//   const handleCountryCodeChange = (code) => {
//     setCountryCode(code);
//     setSearchQuery('');
//   };

//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   const filteredCountries = countries.filter((country) => 
//     country.name.toLowerCase().includes(searchQuery.toLowerCase()) || country.code.includes(searchQuery)
//   );

//   return (
//     <div className='newPhysioSignUp'>
//       <div className='content'>
//         <div className='textContainer'>
//           <div style={{display:"flex"}}>
//             <img src={logo} style={{height:"50px"}} alt="Logo" />
//             <div style={{fontWeight:"600",fontSize:"40px"}}>
//               Wizphys.io
//             </div>
//           </div>
//           <div style={{paddingLeft:"3%", width:"180px", lineHeight:"18px"}}>
//             Everything you need for <br /> speedy recovery
//           </div>
//         </div>
//         <div className="docImageWrapper">
//           <img src='https://firebasestorage.googleapis.com/v0/b/snaiyu-7b192.appspot.com/o/PhysioUIContent%2Fdocimage.png?alt=media&token=18ab9702-e015-4f87-ba5b-8cba69026cc7' alt="Doctor" className="docImage"/>
//         </div>
//       </div>
//       <div className="inputSection">
//         <div className="inputContainer">
//           <div style={{ position: 'relative', display: 'flex', alignItems: 'center', paddingLeft: '2%', fontWeight: '650', paddingRight: '2%', justifyContent: 'space-between' }}>
//             <Dropdown onSelect={handleCountryCodeChange} style={{ marginRight: '10px', fontWeight: '650', fontSize: '120%', height:"48px" }}>
//               <Dropdown.Toggle variant="light" id="dropdown-basic" className="custom-dropdown-toggle">
//                 <ReactCountryFlag countryCode={countries.find(country => country.code === countryCode)?.countryCode} svg style={{ marginLeft: '0px', marginRight: '10px', borderRadius:"100%",transform: 'scale(1.7)' }} /> 
//               </Dropdown.Toggle>

//               <Dropdown.Menu className="dropdown-menu-animated">
//                 <Form.Control 
//                   type="text" 
//                   placeholder="Search country code or name" 
//                   value={searchQuery} 
//                   onChange={handleSearchChange} 
//                   style={{ margin: '5%', width:"90%" }}
//                 />
//                 {filteredCountries.map((country, index) => (
//                   <>
//                     <Dropdown.Item key={country.code} eventKey={country.code}>
//                       <div style={{display: "flex", justifyContent: "space-between"}}>
//                         <div style={{marginRight: "10px"}}>
//                           <ReactCountryFlag countryCode={country.countryCode} svg /> {country.name}
//                         </div>
//                         <div>{country.code}</div>
//                       </div>
//                     </Dropdown.Item>
//                     {index !== filteredCountries.length - 1 && <hr style={{ margin: '0 8px', border: 'none', borderBottom: '2px solid #ccc' }} />}
//                   </>
//                 ))}
//               </Dropdown.Menu>
//             </Dropdown>

//             <div style={{ position: 'relative', width: '100%' }}>
//               <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#000', fontSize:"20px", fontWeight:"600" }}>{countryCode}</span>
//               <Form.Control
//                 type="tel"
//                 className="phone-input"
//                 value={mobileNumber}
//                 onChange={handlePhoneNumberChange}
//                 style={{ paddingLeft: '70px', fontWeight: '600', fontSize: '100%', backgroundColor: '#F6F6F6', border: '0.93px solid #E4E4E4' }}
//                 placeholder="Enter mobile number"
//               />
//             </div>
//           </div>

//           {error && (
//             <div style={{ color: 'red', paddingLeft: "4%", marginTop: '10px', fontWeight: 'bold' }}>
//               {error}
//             </div>
//           )}
//           <div style={{ display: 'flex', justifyContent: 'center' }} id="recaptcha-container"></div>

//           <div style={{ paddingLeft: "4%", display:"flex", paddingTop:"25px", paddingBottom:"5px" }}>
//             <input type="checkbox" id="terms" style={{ backgroundColor: '#F6F6F6', border: '1.33px solid #DBDBDB', transform: 'scale(1.5)', paddingTop:"5px" }} onChange={handleCheckboxChange}/>
//             <label htmlFor="terms" style={{ color: '#2D2F35', fontWeight:"500"}}>I agree to <a href="https://www.wizio.in/physio-agreement" style={{color:"#E09C5C", fontWeight:"600"}}>Terms and Conditions</a></label>
//           </div>
//         <button className={`InputBtn ${!isPhoneNumberValid || !isCheckboxChecked ? 'disabled' : 'enabled'}`} onClick={getOtp} disabled={!isPhoneNumberValid || !isCheckboxChecked}>
//           {isLoading ? 'Loading...' : 'GET STARTED'}
//         </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PhysioNewSignUpPhone;


import React, { useState, useEffect } from 'react';
import logo from '../images/logo_page.png';
import Dropdown from 'react-bootstrap/Dropdown';
import ReactCountryFlag from 'react-country-flag';
import Form from 'react-bootstrap/Form';
import { useUserAuth } from '../context/UserAuthContext';
import { useNavigate } from 'react-router-dom';
import countries from '../utils/countries';

// ✅ Countries where Twilio OTP is active
const TWILIO_SUPPORTED_CODES = new Set([
  '+966', // Saudi Arabia
  '+20',  // Egypt
  '+971', // UAE
  '+965', // Kuwait
  '+974', // Qatar
  '+973', // Bahrain
  '+968', // Oman
  '+44',  // United Kingdom
  '+33',  // France
  '+49',  // Germany
  '+1',   // United States & Canada
  // '+91',  // India
  '+27',  // South Africa
]);

const PhysioNewSignUpPhone = () => {
  const navigate = useNavigate();
  const [mobileNumber, setMobileNumber] = useState('');
  const [countryCode, setCountryCode] = useState('+91');
  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(false);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [error, setError] = useState('');
  const [number, setNumber] = useState('');
  const { setUpRecaptcha, setResult, setPermission } = useUserAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [botTrap, setBotTrap] = useState('');

  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  // Derived: is the current country code supported by Twilio?
  const isTwilioCountry = TWILIO_SUPPORTED_CODES.has(countryCode);

  useEffect(() => {
    const initializeFeatures = async () => {
      try {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            async (position) => {
              const { latitude, longitude } = position.coords;
              try {
                const response = await fetch(`https://geocode.xyz/${latitude},${longitude}?json=1`);
                const data = await response.json();
                const userCountry = countries.find(country => country.name === data.country);
                if (userCountry) {
                  setCountryCode(userCountry.code);
                }
              } catch (error) {
                console.error("Geocoding error:", error);
              }
            },
            (error) => console.error("Geolocation error:", error)
          );
        }

        if ('Notification' in window && !isSafari) {
          try {
            const permission = await Notification.requestPermission();
            setPermission(permission);
          } catch (error) {
            console.error("Notification permission error:", error);
          }
        }
      } catch (error) {
        console.error("Initialization error:", error);
      }
    };

    initializeFeatures();
  }, []);

  const handlePhoneNumberChange = (e) => {
    const inputNumber = e.target.value.replace(/\D/g, '');
    const selectedCountry = countries.find(country => country.code === countryCode);
    const limitedInput = inputNumber.slice(0, 15);
    const isValid = selectedCountry ? limitedInput.length >= selectedCountry.phoneLength : limitedInput.length >= 7;
    setIsPhoneNumberValid(isValid);
    setMobileNumber(limitedInput);

    let numberToSend = limitedInput;
    if (numberToSend.startsWith('0') && numberToSend.length > 1) {
      // Remove the leading '0'
      numberToSend = numberToSend.substring(1);
    }
    setNumber(numberToSend);
  };

  const getOtpViaTwilio = async () => {
    const fullPhoneNumber = `${countryCode}${number}`;
    console.log('Requesting Twilio OTP for:', fullPhoneNumber);

    const response = await fetch(`https://twilioverifyotp-284536061530.us-central1.run.app/request-otp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        phoneNumber: fullPhoneNumber,
        channel: 'sms',
        service: 'Wizphys AI',
      })
    });

    const data = await response.json();

    if (response.ok && data.success) {
      navigate(`/otp/${countryCode.substring(1)}/${number}`);
    } else {
      throw new Error(data.details || "Failed to send OTP. Please try again.");
    }
  };

  // ✅ Firebase OTP path (unsupported countries)
  const getOtpViaFirebase = async () => {
    console.log('Requesting Firebase OTP for:', countryCode, number);
    const result = await setUpRecaptcha(number, countryCode);
    setResult(result);
    navigate(`/otp/${countryCode.substring(1)}/${number}`);
  };

  const getOtp = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      // For Safari, request notification permission as part of button click
      if (isSafari && 'Notification' in window) {
        try {
          const permission = await Notification.requestPermission();
          setPermission(permission);
        } catch (err) {
          console.error("Safari notification permission error:", err);
        }
      }

      if (isTwilioCountry) {
        await getOtpViaTwilio();
      } else {
        await getOtpViaFirebase();
      }
    } catch (err) {
      console.error("OTP error:", err);
      if (err.code === 'auth/invalid-phone-number') {
        setError("Invalid phone number. Please check the number and try again.");
      } else {
        setError(err.message || "Something went wrong. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleCheckboxChange = (e) => {
    setIsCheckboxChecked(e.target.checked);
  };

  const handleCountryCodeChange = (code) => {
    setCountryCode(code);
    setSearchQuery('');
    // Reset phone validation when country changes
    setMobileNumber('');
    setNumber('');
    setIsPhoneNumberValid(false);
    setError('');
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredCountries = countries.filter((country) =>
    country.name.toLowerCase().includes(searchQuery.toLowerCase()) || country.code.includes(searchQuery)
  );

  return (
    <div className='newPhysioSignUp'>
      <div className='content'>
        <div className='textContainer'>
          <div style={{ display: "flex" }}>
            <img src={logo} style={{ height: "50px" }} alt="Logo" />
            <div style={{ fontWeight: "600", fontSize: "40px" }}>
              Wizphys.io
            </div>
          </div>
          <div style={{ paddingLeft: "3%", width: "180px", lineHeight: "18px" }}>
            Everything you need for <br /> speedy recovery
          </div>
        </div>
        <div className="docImageWrapper">
          <img src='https://firebasestorage.googleapis.com/v0/b/snaiyu-7b192.appspot.com/o/PhysioUIContent%2Fdocimage.png?alt=media&token=18ab9702-e015-4f87-ba5b-8cba69026cc7' alt="Doctor" className="docImage" />
        </div>
      </div>

      <div className="inputSection">
        <div className="inputContainer">
          <input
            type="text"
            autoComplete="off"
            style={{ display: 'none' }}
            tabIndex="-1"
            value={botTrap}
            onChange={(e) => setBotTrap(e.target.value)}
          />
          <div style={{ position: 'relative', display: 'flex', alignItems: 'center', paddingLeft: '2%', fontWeight: '650', paddingRight: '2%', justifyContent: 'space-between' }}>
            <Dropdown onSelect={handleCountryCodeChange} style={{ marginRight: '10px', fontWeight: '650', fontSize: '120%', height: "48px" }}>
              <Dropdown.Toggle variant="light" id="dropdown-basic" className="custom-dropdown-toggle">
                <ReactCountryFlag
                  countryCode={countries.find(country => country.code === countryCode)?.countryCode}
                  svg
                  style={{ marginLeft: '0px', marginRight: '10px', borderRadius: "100%", transform: 'scale(1.7)' }}
                />
              </Dropdown.Toggle>

              <Dropdown.Menu className="dropdown-menu-animated">
                <Form.Control
                  type="text"
                  placeholder="Search country code or name"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  style={{ margin: '5%', width: "90%" }}
                />
                {filteredCountries.map((country, index) => (
                  <React.Fragment key={country.code + country.name}>
                    <Dropdown.Item eventKey={country.code}>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ marginRight: "10px" }}>
                          <ReactCountryFlag countryCode={country.countryCode} svg /> {country.name}
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                          {/* ✅ Visual indicator: shows whether country uses Twilio or Firebase */}
                          <span style={{
                            fontSize: "9px",
                            padding: "1px 5px",
                            borderRadius: "4px",
                            backgroundColor: TWILIO_SUPPORTED_CODES.has(country.code) ? "#e6f4ea" : "#fef3e2",
                            color: TWILIO_SUPPORTED_CODES.has(country.code) ? "#1e7e34" : "#b45309",
                            fontWeight: "600"
                          }}>
                            {TWILIO_SUPPORTED_CODES.has(country.code) ? "SMS" : "APP"}
                          </span>
                          {country.code}
                        </div>
                      </div>
                    </Dropdown.Item>
                    {index !== filteredCountries.length - 1 && (
                      <hr style={{ margin: '0 8px', border: 'none', borderBottom: '2px solid #ccc' }} />
                    )}
                  </React.Fragment>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            <div style={{ position: 'relative', width: '100%' }}>
              <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#000', fontSize: "20px", fontWeight: "600" }}>
                {countryCode}
              </span>
              <Form.Control
                type="tel"
                className="phone-input"
                value={mobileNumber}
                onChange={handlePhoneNumberChange}
                style={{ paddingLeft: '70px', fontWeight: '600', fontSize: '100%', backgroundColor: '#F6F6F6', border: '0.93px solid #E4E4E4' }}
                placeholder="Enter mobile number"
              />
            </div>
          </div>

          {/* ✅ Subtle hint for non-Twilio countries so users know what to expect */}
          {/* {!isTwilioCountry && mobileNumber.length > 0 && (
            <div style={{ color: '#b45309', paddingLeft: "4%", marginTop: '6px', fontSize: '13px', fontWeight: '500' }}>
              OTP will be sent via your authenticator app
            </div>
          )} */}

          {error && (
            <div style={{ color: 'red', paddingLeft: "4%", marginTop: '10px', fontWeight: 'bold' }}>
              {error}
            </div>
          )}

          {/* ✅ Required for Firebase web recaptcha — hidden for Twilio countries */}
          {!isTwilioCountry && (
            <div style={{ display: 'flex', justifyContent: 'center' }} id="recaptcha-container"></div>
          )}

          <div style={{ paddingLeft: "4%", display: "flex", paddingTop: "25px", paddingBottom: "5px" }}>
            <input
              type="checkbox"
              id="terms"
              style={{ backgroundColor: '#F6F6F6', border: '1.33px solid #DBDBDB', transform: 'scale(1.5)', paddingTop: "5px" }}
              onChange={handleCheckboxChange}
            />
            <label htmlFor="terms" style={{ color: '#2D2F35', fontWeight: "500" }}>
              I agree to <a href="https://www.wizio.in/physio-agreement" style={{ color: "#E09C5C", fontWeight: "600" }}>Terms and Conditions</a>
            </label>
          </div>

          <button
            className={`InputBtn ${!isPhoneNumberValid || !isCheckboxChecked ? 'disabled' : 'enabled'}`}
            onClick={getOtp}
            disabled={!isPhoneNumberValid || !isCheckboxChecked || isLoading}
          >
            {isLoading ? 'Loading...' : 'GET STARTED'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PhysioNewSignUpPhone;